<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack class="flex justify-end">
					<router-link
						to="/admin/contactos-categorias"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="contacts_categories"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { fetchContactCategoryList } from '@/apollo/queries/admin/contacts_category_list'

export default {
	apollo: {
		contacts_categories: fetchContactCategoryList()
	},
	data() {
		return {
			section: 'contactos-categorias',
			itemsTable: 'contacts_categories',
			itemsTitles: ['Id', 'Nombre', 'Pais', 'Orden']
		}
	},
	components: {
		ListTable
	}
}
</script>
